import type { ReactNode } from "react";
import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

type SectionHelpTooltipProps = {
  /** Содержимое подсказки (абзацы, списки). */
  children: ReactNode;
  /** aria-label кнопки. */
  label?: string;
  side?: "top" | "right" | "bottom" | "left";
  className?: string;
};

/**
 * Иконка «?» у заголовка раздела: развёрнутая справка (назначение, жесты, клавиши).
 * Открывается только по явному клику/активации кнопки (не по автофокусу Dialog).
 */
export function SectionHelpTooltip({
  children,
  label = "Справка по разделу",
  side = "right",
  className,
}: SectionHelpTooltipProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-muted-foreground",
            "hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            className,
          )}
          aria-label={label}
        >
          <HelpCircle className="h-4 w-4" aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        align="start"
        // z выше Sheet/Dialog (z-[220]), как у ui/tooltip.
        className="z-[300] w-auto max-w-sm space-y-2 border bg-popover p-3 text-left text-xs font-normal leading-snug text-popover-foreground shadow-md"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
